import getFeature from "@src/template/helpers/getFeature";

const getFeatureVariables = async featureName => {
  const feature = await getFeature(featureName);

  if (feature) {
    return feature.getVariables();
  }

  return null;
};

export default getFeatureVariables;
